import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import { PrivacyPolicy, CookiePolicy, Terms } from "@/pages/LegalPages";
import ThankYou from "@/pages/ThankYou";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/ar" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />

          <Route element={<Layout />}>
            <Route path="/ar" element={<Home />} />
            <Route path="/ar/privacy" element={<PrivacyPolicy />} />
            <Route path="/ar/cookies" element={<CookiePolicy />} />
            <Route path="/ar/terms" element={<Terms />} />

            <Route path="/en" element={<Home />} />
            <Route path="/en/privacy" element={<PrivacyPolicy />} />
            <Route path="/en/cookies" element={<CookiePolicy />} />
            <Route path="/en/terms" element={<Terms />} />
          </Route>

          <Route path="*" element={<Navigate to="/ar" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
